import React from "react";
import SingleCameraContainer from "../components/singleCamera/SingleCameraContainer";

const SingleCamera = () => {
  return <SingleCameraContainer />;
};

export default SingleCamera;
